/* Optibio entry tracking, R1c 2026-09-25 (plan v3, Release 1c): which button sold.

   Sources: pdp-buybox, door-buybox, offer-buybox, other-buybox (the #obMainCta button in
   snippets/optibio-buybox-card.liquid, named after the page it sits on), sticky-bar
   (sections/cd-sticky-cta.liquid), article-inline (snippets/ob-inline-buy.liquid) and
   article-end (snippets/blog-product-cta.liquid).

   A button names itself just before its product form submits: its click handler calls
   obEntry.mark(source, component), or, when it has no script of its own, it carries
   data-ob-entry="<source>". The name waits on that <product-form-component>. Once Horizon
   reports the add went through (cart:update from that component, no didError), this file
     1. sends the Clarity event atc_<source>, and
     2. writes the cart attributes _ob_entry_first (only when the cart has none yet) and
        _ob_entry_last, each "<source>|<ISO time>". The underscore keeps both hidden from
        shoppers; they travel with the order.
   snippets/visit-tracking.liquid puts obEntry.current() in its "Added to cart" row.

   Nothing here runs ahead of the add or holds it up, and every failure is swallowed.
   Loaded on every page by snippets/visit-tracking.liquid. */
(function () {
  'use strict';

  if (window.obEntry) return;

  var PENDING = 'data-ob-entry-pending';
  var inFlight = '';

  /* component is the <product-form-component> that is about to send the add. */
  function mark(source, component) {
    if (!source) return;
    inFlight = source;
    if (component && component.setAttribute) component.setAttribute(PENDING, source);
  }

  function record(source) {
    var stamp = source + '|' + new Date().toISOString();
    try { if (window.clarity) window.clarity('event', 'atc_' + source); } catch (e) {}
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var attributes = { _ob_entry_last: stamp };
          if (!(cart && cart.attributes && cart.attributes._ob_entry_first)) attributes._ob_entry_first = stamp;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attributes })
          });
        })
        .catch(function () {});
    } catch (e) {}
  }

  /* A button with no script of its own (the article end card) carries its name. */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-ob-entry]') : null;
    if (el) mark(el.getAttribute('data-ob-entry'), el.closest('product-form-component'));
  }, true);

  /* Horizon dispatches cart:update on the product form component once /cart/add.js answers.
     A refused add fires cart:error; cart:update with didError follows only when the form has
     an error text ref, which our custom forms do not, so cart:error clears the name below.
     Cart updates from anywhere else (the drawer, other product forms) carry no pending name. */
  document.addEventListener('cart:update', function (e) {
    var component = e.target;
    var data = (e.detail && e.detail.data) || {};
    if (data.source !== 'product-form-component' || !component || !component.getAttribute) return;
    var source = component.getAttribute(PENDING);
    if (!source) return;
    component.removeAttribute(PENDING);
    inFlight = '';
    if (!data.didError) record(source);
  });

  document.addEventListener('cart:error', function (e) {
    var component = e.target;
    if (!component || !component.getAttribute || !component.getAttribute(PENDING)) return;
    component.removeAttribute(PENDING);
    inFlight = '';
  });

  window.obEntry = {
    mark: mark,
    /* The name of the add being sent right now, or '' when no button named one. */
    current: function () { return inFlight; }
  };
})();
